<template>
  <icool-icon :icon="icon" />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CloudStatus',
  computed: {
    ...mapGetters('app', [
      'isConnectionOk',
    ]),
    icon() {
      if (this.isConnectionOk) {
        return 'connection-ok';
      }
      return 'connection-fail';
    },
  },
};
</script>

<style scoped>

</style>
